import { useEffect, useState } from 'react';
var PREFIX = 'jove';

function getKey(key) {
  return "".concat(PREFIX, "-").concat(key);
}

function getSessionStorageValue(key, defaultValue) {
  var saved = defaultValue;

  if (true) {
    try {
      var _sessionStorage$getIt;

      saved = (_sessionStorage$getIt = sessionStorage.getItem(getKey(key))) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : defaultValue;
    } catch (_) {}
  }

  return saved;
}

function setSessionStorageValue(key, value) {
  sessionStorage.setItem(getKey(key), value);
  return value;
}

export function useSessionStorage(key, defaultValue) {
  var _useState = useState(function () {
    return getSessionStorageValue(key, defaultValue);
  }),
      value = _useState[0],
      setValue = _useState[1];

  useEffect(function () {
    setValue(getSessionStorageValue(key, defaultValue));
  }, [key]);
  useEffect(function () {
    setSessionStorageValue(key, value);
  }, [key, value]);
  return [value, setValue];
}